export class ChatMessage {
    content: string;
    chatUserId: number;
    userName: string;
    when: Date;
    avatar: string;
    dateStr: string;
}
